<template>
	<div class="dashboard">
		<header class="header-title">今日數據</header>

		<el-row class="stats-panel" type="flex">
			<el-col v-for="(item, idx) in stats" :key="idx" :span="8"
				:class="['stat-item', { 'border-left': idx > 0 }]">
				<div class="label">
					{{ item.label }}
					<i v-if="item.info" class="el-icon-info"></i>
				</div>
				<div :class="['value', item.color]">{{ item.value }}</div>
			</el-col>
		</el-row>

		<section class="chart-section">
			<div class="chart-header">
				<div class="title-box">
					<b class="main">會話量趨勢</b>
					<small class="sub">每小時更新數據</small>
				</div>
				<div class="filter">
					<el-date-picker v-model="query.range" type="datetimerange" size="small"
						style="width: 340px; margin-right: 12px;" />
					<el-select v-model="query.unit" size="small" style="width: 80px;">
						<el-option label="小時" value="hour" />
						<el-option label="天" value="day" />
					</el-select>
				</div>
			</div>

			<line-chart :chart-data="chartData" :x-axis-data="xAxisData" />
		</section>
	</div>
</template>

<script>
import LineChart from './components/LineChart.vue';

export default {
	components: { LineChart },
	data() {
		return {
			query: { range: ['2026-01-19 00:00', '2026-01-20 00:00'], unit: 'hour' },
			stats: [
				{ label: '今日新會話數', value: 0, color: 'green', info: true },
				{ label: '處理中會話數', value: 7, color: 'orange' },
				{ label: '線上成員數', value: 1, color: '' }
			],
			// 模拟数据
			xAxisData: ['00:00', '06:00', '12:00', '18:00', '00:00'],
			chartData: [12, 5, 1, 8, 6]
		};
	}
};
</script>

<style lang="scss" scoped>
$border-color: #f0f0f0;

.dashboard {
	padding: 24px;
	background: #fff;

	.header-title {
		font-size: 14px;
		color: #666;
		margin-bottom: 20px;
	}

	.stats-panel {
		padding: 40px 0;
		border-bottom: 1px solid $border-color;
		text-align: center;

		.stat-item {
			.label {
				font-size: 14px;
				color: #909399;
				margin-bottom: 12px;

				i {
					color: #ccc;
					margin-left: 4px;
				}
			}

			.value {
				font-size: 48px;

				&.green {
					color: #67C23A;
				}

				&.orange {
					color: #E6A23C;
				}
			}

			&.border-left {
				border-left: 1px solid $border-color;
			}
		}
	}

	.chart-section {
		margin-top: 24px;

		.chart-header {
			display: flex;
			justify-content: space-between;
			margin-bottom: 24px;

			.title-box {
				.main {
					display: block;
					font-size: 16px;
				}

				.sub {
					color: #999;
					font-size: 12px;
				}
			}

			.filter {
				display: flex;
				align-items: center;
			}
		}
	}
}
</style>